import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { MultisiteSwitchComponentDef } from '@df/ui/multisite/multisite-switch.component.def';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { MultisiteFlagComponent } from './multisite-flag.component';

@Component({
    selector: 'multisite-switch',
    templateUrl: './multisite-switch.component.html',
    standalone: true,
    imports: [CommonModule, HideUpComponent, MultisiteFlagComponent, ToggleModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteSwitchComponent extends MultisiteSwitchComponentDef {}
